import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisplayManagerService {
  index$: BehaviorSubject<string> = new BehaviorSubject<string>('0');

  horizontalDown = 0;
  verticalDown = 0;

  constructor(private renderer: Renderer2) {}

  init(index: number, swipeZoneElement?: ElementRef) {
    this.setIndex(index);
    if (swipeZoneElement) {
      this.initListeners(
        swipeZoneElement,
        ['touchstart', 'touchend'],
        this.renderer
      );
    }
  }

  initListeners(
    swipeZoneElement: ElementRef,
    events: string[],
    renderer: Renderer2
  ) {
    events.forEach((eventName: string) => {
      renderer.listen(
        swipeZoneElement.nativeElement,
        eventName,
        (event: Event) => {
          if (eventName === 'touchstart') {
            this.horizontalDown = (<TouchEvent>event).touches[0].clientX;
            this.verticalDown = (<TouchEvent>event).touches[0].clientY;
          } else if (eventName === 'touchend') {
            const horizontalUp = (<TouchEvent>event).changedTouches[0].clientX;
            const verticalUp = (<TouchEvent>event).changedTouches[0].clientY;
            this.handleSwipe(
              this.horizontalDown - horizontalUp,
              this.verticalDown - verticalUp,
              this.index$.value
            );
            this.horizontalDown = 0;
            this.verticalDown = 0;
          }
        }
      );
    });
  }

  handleSwipe(horizontalDiff: number, verticalDiff: number, index: string) {
    if (Math.abs(horizontalDiff) > Math.abs(verticalDiff)) {
      if (horizontalDiff > 0) {
        this.performSwipeActions('right', index);
      } else {
        this.performSwipeActions('left', index);
      }
    }
  }

  setIndex(index: number) {
    this.index$.next(`${index}`);
  }

  performSwipeActions(side: string, index: string): void {
    if (side === 'right') {
      +index !== 4 && this.index$.next(`${+index + 1}`);
    } else {
      +index !== 0 && this.index$.next(`${+index - 1}`);
    }
  }
}
